import { render, staticRenderFns } from "./CadastroAutoUrg.vue?vue&type=template&id=0e47b4cb&"
import script from "./CadastroAutoUrg.vue?vue&type=script&lang=js&"
export * from "./CadastroAutoUrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports